import type { TOC } from '@ember/component/template-only';
import SettingsHotelAccessFormsFormUserEdit from 'lumen/components/settings/hotel-access/forms/form-user-edit';
import type HotelSettingsHotelsEditController from 'lumen/controllers/hotel/settings/hotels/edit';

interface HotelSettingsHotelsEditSignature {
  Args: {
    controller: HotelSettingsHotelsEditController;
    model: unknown;
  };
}

<template>
  <SettingsHotelAccessFormsFormUserEdit
    @changeHotelSearch={{@controller.changeHotelSearch}}
    @editText={{@controller.editText}}
    {{! @glint-expect-error: Incorrect type }}
    @hotelText={{@controller.hotelText}}
    @model={{@controller.model}}
    @redirectOnClose={{@controller.redirectOnClose}}
    @refreshData={{@controller.refreshData}}
    @sortResults={{@controller.sortResults}}
    @userId={{@controller.userId}}
  />
</template> satisfies TOC<HotelSettingsHotelsEditSignature>;
